import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

import Home from './Components/Home';
import Footer from './Components/Footer';
import Navbar from './Components/Navbar';
import NextNavbar from './Components/NextNavbar';
import Gallery from './Components/Gallery';
import Facilities from './Components/Facilities';
import ContactUs from './Components/ContactUs';
import AcademicPRocedure from './Components/AcademicPRocedure';
import OurSchool from './Components/OurSchool';
import Updates from './Components/Updates';
import BoardD from './Components/BoardD';
import Principal from './Components/Principal';
import ScrollToTop from './Components/ScrollToTop';

import "./App.css";

// Initialize Google Analytics with your GA4 Measurement ID
ReactGA.initialize("G-20C73MSB60");  

// Custom hook to track page views on every route change
function usePageTracking() {
  // Get current URL path from React Router
  const location = useLocation();

  // When location changes, send pageview info to Google Analytics
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);
}

// This component contains main app layout and routing
function AppContent() {
  // Enable page tracking when this component is used
  usePageTracking();

  return (
    <>
      {/* Show updates banner or notifications */}
      <Updates />
      <Navbar />
      <NextNavbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/facilities" element={<Facilities />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/academicprocedure" element={<AcademicPRocedure />} />
        <Route path="/ourschool" element={<OurSchool />} />
        <Route path="/boarddirector" element={<BoardD />} />
        <Route path="/principal" element={<Principal />} />
      </Routes>
      <Footer />
    </>
  );
}

// Root app component wrapping everything inside React Router
function App() {
  return (
    <div className="container-fluid mainbgcch p-0">
      <BrowserRouter>
        {/* ScrollToTop helps to reset scroll on navigation */}
        <ScrollToTop />
        
        {/* Main app content with routes and tracking */}
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
